import * as type from "../../types/API/reconcileAndUploadType";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const stockReconcileReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.STOCK_RECONCILE:
      return {
        ...state,
        loading: true,
      };
    case type.STOCK_RECONCILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.STOCK_RECONCILE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};